var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"font-size":"60px","margin":"10px","letter-spacing":"10px","text-align":"center","color":"#ffffff"}},[_c('el-row',[_c('el-col',{attrs:{"xs":24,"sm":24,"md":24,"lg":24,"xl":24}},[_vm._v(" 做简单的更好 ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }